import type { TOC } from '@ember/component/template-only';
import { PrismIllustration } from '@mylighthouse/prism-ember';

interface GeneralMessagingBannerSignature {
  Args: {
    alt?: string;
    image?: string;
    subtitle?: string;
    title?: string;
  };
  Blocks: {
    default: [];
  };
}

const GeneralMessagingBanner = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <div class="messaging-banner__wrapper flex items-center justify-center">
    <div class="messaging-banner__content flex items-center justify-center">

      <div class="flex flex-row">
        {{#if @image}}
          <PrismIllustration
            @name={{@image}}
            @size="unsafe_unconstrained"
            aria-label={{@alt}}
            class="mr-500"
          />
        {{/if}}

        <div class="messaging-banner__text flex flex-col gap-300">
          {{#if @title}}
            <h3>{{@title}}</h3>
          {{/if}}
          {{#if @subtitle}}
            <p class="text-300--regular">{{@subtitle}}</p>
          {{/if}}
        </div>
      </div>

      {{yield}}

    </div>

  </div>
</template> satisfies TOC<GeneralMessagingBannerSignature>;

export default GeneralMessagingBanner;
